import * as S from "@styled";
import { buttonColorDisabled, buttonBackgroundAndBorderColorDisabled } from "./button/Button";
import styled, { createGlobalStyle } from "styled-components";

export const AiAssistantGradientAnimationStyles = createGlobalStyle`
  @property --gradient-angle {
    syntax: "<angle>";
    initial-value: 90deg;
    inherits: false;
  }

  @keyframes rotate {
    0% {
      --gradient-angle: 0deg;
    }
    100% {
      --gradient-angle: 360deg;
    }
  }
`;

export const StyledAiButton = styled(S.Button)`
  position: relative;
  border: 0px !important;

  --clr-1: #6717ff;
  --clr-2: #aa8dfa;
  --clr-3: #d9ccfd;
  background-color: ${S.Colors.purpleBackground} !important;
  color: ${S.Colors.purplePrimary} !important;

  &:hover {
    color: ${S.Colors.purplePrimary} !important;
    background-color: ${S.Colors.purpleTertiary} !important;
  }
  &:disabled {
    &:before,
    &:after {
      background: unset !important;
    }
    color: ${buttonColorDisabled} !important;
    background-color: ${buttonBackgroundAndBorderColorDisabled} !important;
  }
  &:after,
  &:before {
    content: " ";
    position: absolute;
    z-index: -1;
    inset: -2px;
    background: conic-gradient(
      from var(--gradient-angle),
      var(--clr-1),
      var(--clr-2),
      var(--clr-3),
      var(--clr-2),
      var(--clr-1)
    );
    border-radius: 15px;
    animation: rotate 3s linear infinite;
  }

  &:after {
    filter: blur(6px);
  }
`;
